// Registers the service worker for PWA + web-push
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.hostname === "localhost") return; // avoid dev noise
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("SW registered:", reg.scope);
      })
      .catch(() => {});
  });
}

// Ask browser permission for notifications (required before web push).
// Real web push subscription requires a VAPID public key + backend endpoint (documented in PRD).
export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try { return await Notification.requestPermission(); } catch { return "denied"; }
}
